<template>
  <div class="mr-4 ml-4" style="width: 90vw;">
    <div class="row w-100 text-primary mb-4" style="font-size: 1rem;">
      <b class="mr-1">Instrucciones: </b> {{instructions}}
    </div>

    <div class="row w-100">
      <div class="col-md text-center">
        <button v-if="!isPlaying" class="btn btn-success w-50" @click="start()">
          <i class="fas fa-play-circle"></i>
          Comenzar
        </button>
        <button v-else class="btn btn-danger w-50" @click="stop()">
          <i class="fas fa-stop-circle"></i>
          Detener
        </button>
      </div>
      <div class="col-md text-center">
        <button v-if="!isOnPause" class="btn btn-primary w-50" :disabled="!isPlaying || countDownValue > 0" @click="pause()">
          <i class="fas fa-pause-circle"></i>
          Pausar
        </button>
        <button v-else class="btn btn-success w-50" :disabled="!isPlaying || countDownValue > 0" @click="resume()">
          <i class="fas fa-play-circle"></i>
          Continuar
        </button>
      </div>
    </div>

    <div class="row w-100">
      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div class="row text-center w-100">
      <div class="card pb-4 text-primary">
        <div class="card-body">
          <div class="row" v-if="countDownValue > 0">
            <div class="col-lg text-center" v-if="isPlaying">
              ¡Prepárate!
              <br>
              <span style="font-size: 2.5rem;">{{countDownValue}}</span> 
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-lg pt-3 text-justify" style="font-size: 1.5rem;">
              <span 
              v-for="(word, index) in allWords" :key="`${word}-${index}`"
              :class="currentWordsIndex >= index ? 'unread read mr-0 pr-0' : 'unread mr-0 pr-0'">
                {{`${word}`}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'automatic-reading',
  interval: null,
  startInterval: null,
  props: {
    instructions: {
      type: String,
      default: 'Cuando estés listo da clic en "Comenzar" y realiza la lectura conforme se vayan subrayando las palabras, al final sabras que tan rápido has leído.'
    },
    text: {
      type: String,
      required: true
    },
    timerPerWord: {
      type: Number,
      default: 1,
      validator: (value) => {
        if (value >= 1) return true;
        return false;
      }
    },
  },
  data() {
    return {
      currentWordsIndex: 0,
      isOnPause: false,
      isPlaying: false,
      countDownValue: 3,
      successMessage: ''
    }
  },
  computed: {
    allWords() {
      return this.text.split(' ').filter(word => word && word !== '\n');
    },
    allWordsLength() {
      return this.allWords.length;
    }
  },
  methods: {
    start() {
      this.successMessage = '';
      this.countDownValue = 3;
      this.currentWordsIndex = 0;
      this.isOnPause = false;
      this.isPlaying = true;
      this.initCountDown();
      setTimeout(() => {
        this.setInterval();
      }, 3000);
    },
    stop() {
      if (this.countDownValue > 0) return;
      this.currentWordsIndex = 0;
      this.countDownValue = 3;
      this.isOnPause = false;
      this.isPlaying = false;
      clearInterval(this.interval);
    },
    pause(){
      this.isOnPause = true;
      this.isPlaying = true;
      clearInterval(this.interval);
    },
    resume(){
      this.isOnPause = false;
      this.isPlaying = true;
      this.setInterval();
    },
    setInterval() {
      this.interval = setInterval(() => {
        if (this.currentWordsIndex + 1 == this.allWordsLength) {
          this.stop();
          this.successMessage = `¡Has terminado!, leiste ${((this.allWordsLength * (this.timerPerWord * this.allWordsLength))/60).toFixed(2)} palabras por minuto`
        } else this.currentWordsIndex = this.currentWordsIndex + 1;
      }, this.timerPerWord * 1000);
    },
    initCountDown(){
      this.startInterval = setInterval(() => {
        this.countDownValue = this.countDownValue - 1;
        if (this.countDownValue == 0) clearInterval(this.startInterval);
      }, 1000);
    }
  }
}
</script>

<style scoped>
.btn-success {
  background-color: rgba(24, 206, 15, 0.8);
}

.unread {
  background-image: linear-gradient(to right, white 50%, yellow 50%);
  background-position: 0;
  background-size: 200%;
  transition: all 0.5s linear;
}
.read {
  background-position: -100%;
}
</style>
